import { render, staticRenderFns } from "./sign_stocksake2.vue?vue&type=template&id=13a9bf5b&scoped=true"
import script from "./sign_stocksake2.vue?vue&type=script&lang=js"
export * from "./sign_stocksake2.vue?vue&type=script&lang=js"
import style0 from "./sign_stocksake2.vue?vue&type=style&index=0&id=13a9bf5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a9bf5b",
  null
  
)

export default component.exports